import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// Create the Zustand store
const useStatisticStore = create(
  persist(
    (set, get) => ({
      // Initial state
      statistic: {
        newApplicants: 0,
        newApplications: 0,
        // Add other default properties here if needed
      },

      // Set statistic data
      setStatistic: (data) => {
        set((state) => ({
          statistic: { ...state.statistic, ...data },
        }));
      },

      // Decrease the number of new applicants
      decreaseNumNewApplicants: () => {
        set((state) => {
          const newCount = state.statistic.newApplicants > 0 ? state.statistic.newApplicants - 1 : 0;
          return {
            statistic: { ...state.statistic, newApplicants: newCount },
          };
        });
      },

      // Decrease the number of new applications
      decreaseNumNewApplications: () => {
        set((state) => {
          const newCount = state.statistic.newApplications > 0 ? state.statistic.newApplications - 1 : 0;
          return {
            statistic: { ...state.statistic, newApplications: newCount },
          };
        });
      },
    }),
    {
      name: 'statistic-storage', // Key for Zustand's localStorage persistence
    }
  )
);

export default useStatisticStore;
